import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { SubscriptionCard } from '../SubscriptionCard';
import { PaymentInformationBlock } from '../PaymentInformationBlock';
import styles from './SubscriptionPlanSelector.css';

const cx = classnames.bind(styles);

function SubscriptionPlanSelector({ className, plans, onSubmit, defaultPlan, isPending }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const [selectedSubcriptionData, selectSubscription] = useState(plans.find(({ plan }) => plan === defaultPlan) || {});

    useEffect(() => {
        if (defaultPlan) {
            selectSubscription(plans.find(({ plan }) => plan === defaultPlan) || {});
        }
    }, [defaultPlan]);

    return (
        <div className={classes}>
            <div className={styles.plans} role='radiogroup'>
                {plans.map(plan => (
                    <SubscriptionCard
                        subscriptionData={plan}
                        selectedSubcriptionData={selectedSubcriptionData}
                        selectSubscription={selectSubscription}
                        key={plan.plan}
                    />
                ))}
            </div>
            <Button
                label='Subscribe'
                onClick={() => onSubmit(selectedSubcriptionData)}
                className={cx('button', 'custom')}
                isLoading={isPending}
            />
            <PaymentInformationBlock />
        </div>
    );
}

SubscriptionPlanSelector.propTypes = {
    className: PropTypes.string,
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    defaultPlan: PropTypes.string,
    isPending: PropTypes.bool
};

SubscriptionPlanSelector.defaultProps = {
    className: '',
    isPending: false
};

export {
    SubscriptionPlanSelector
};
